<template>
    <div>
        <section class="q10__jumbotron">
            <image-with-descriptions
                class="mb-8 mt-0"
                :options="{
                    image:
                        'pages/' +
                        currentPage.slug +
                        '/' +
                        currentPage.images.oImage1.src,
                    descriptions: [
                        {
                            text: currentPage.images.oImage1.alt,
                            position: 'bottom-right', // top/bottom-left/right
                            orientation: 'horizontal', // vertical, horizontal
                        },
                        {
                            text: currentPage.images.oImage1.text,
                            position: 'bottom-left', // top/bottom-left/right
                            orientation: 'horizontal', // vertical, horizontal
                        },
                    ],
                }"
            />
        </section>
        <div class="page">
            <div class="container px-11 2xl:px-3 mb-14 m-auto">
                <title-s-chapter
                    :options="{
                        from: 'from-sushi',
                        to: 'to-golden_sand',
                    }"
                >
                    <h1 v-html="currentPage.content.sArticleTitle.text"></h1>
                </title-s-chapter>
                <p
                    class="font-bold text-tundora text-xl mb-5"
                    v-html="currentPage.content.sArticleDescription.text"
                ></p>

                <div class="container-components">
                    <div class="card">
                        <TitleParagraph
                            :options="{
                                from: 'from-sushi',
                                to: 'to-golden_sand',
                            }"
                        >
                            <Triangles
                                :options="{
                                    colors: ['#81C341', '#B7DD92', '#cce5a4'],
                                    direction: 'top',
                                }"
                            />
                            <span
                                v-html="
                                    currentPage.content.sParagraphOne_Title.text
                                "
                            ></span>
                        </TitleParagraph>
                        <p
                            class="text-nandor 2xl:text-lg"
                            v-html="
                                currentPage.content.sParagraphOne_Content.text
                            "
                        ></p>
                    </div>
                    <div class="card">
                        <TitleParagraph
                            :options="{
                                from: 'from-sushi',
                                to: 'to-golden_sand',
                            }"
                            class="inline-flex"
                        >
                            <span
                                v-html="
                                    currentPage.content.sParagraphTwo_Title.text
                                "
                            ></span>
                            <Triangles
                                :options="{
                                    colors: ['#81C341', '#B7DD92', '#cce5a4'],
                                    direction: 'bottom',
                                }"
                            />
                        </TitleParagraph>
                        <p
                            class="text-nandor 2xl:text-lg"
                            v-html="
                                currentPage.content.sParagraphTwo_Content.text
                            "
                        ></p>
                        <div>
                            <image-with-descriptions
                                :options="{
                                    image:
                                        'pages/' +
                                        currentPage.slug +
                                        '/' +
                                        currentPage.images.oImage2.src,
                                    descriptions: [
                                        {
                                            text: currentPage.images.oImage2
                                                .edf,
                                            position: 'bottom-right', // top/bottom-left/right
                                            orientation: 'horizontal', // vertical, horizontal
                                        },
                                    ],
                                }"
                            />
                        </div>
                    </div>
                    <div class="card">
                        <TitleParagraph
                            :options="{
                                from: 'from-sushi',
                                to: 'to-golden_sand',
                            }"
                        >
                            <Triangles
                                :options="{
                                    colors: ['#81C341', '#B7DD92', '#cce5a4'],
                                    direction: 'bottom',
                                }"
                            />
                            <span
                                v-html="
                                    currentPage.content.sParagraphThree_Title
                                        .text
                                "
                            ></span>
                        </TitleParagraph>
                        <paragraph
                            :options="{
                                color: 'text-nandor',
                            }"
                        >
                            <span
                                v-html="
                                    currentPage.content.sParagraphThree_Content
                                        .text
                                "
                            >
                            </span>
                        </paragraph>
                        <div>
                            <image-with-descriptions
                                :options="{
                                    image:
                                        'pages/' +
                                        currentPage.slug +
                                        '/' +
                                        currentPage.images.oImage3.src,
                                    descriptions: [
                                        {
                                            text: currentPage.images.oImage3
                                                .alt,
                                            position: 'bottom-right', // top/bottom-left/right
                                            orientation: 'horizontal', // vertical, horizontal
                                        },
                                        {
                                            text: currentPage.images.oImage3
                                                .text,
                                            position: 'top-left', // top/bottom-left/right
                                            orientation: 'horizontal', // vertical, horizontal
                                        },
                                    ],
                                }"
                            />
                        </div>
                    </div>
                    <div class="card">
                        <div class="break-inside-avoid">
                            
                            <TitleParagraph
                                :options="{
                                    from: 'from-sushi',
                                    to: 'to-golden_sand',
                                }"
                            >
                                <span
                                    v-html="
                                        currentPage.content.sParagraphFour_Title
                                            .text
                                    "
                                ></span>
                                <Triangles
                                    :options="{
                                        colors: [
                                            '#81C341',
                                            '#B7DD92',
                                            '#cce5a4',
                                        ],
                                        direction: 'bottom',
                                    }"
                                />
                            </TitleParagraph>
                            <paragraph
                                :options="{
                                    color: 'text-nandor',
                                }"
                            >
                                <span
                                    v-html="
                                        currentPage.content
                                            .sParagraphFour_Content.text
                                    "
                                ></span>
                                <!-- <Dots
                                    :options="{
                                        colors: [
                                            '#81C341',
                                            '#B7DD92',
                                            '#cce5a4',
                                        ],
                                    }"
                                /> -->
                            </paragraph>
                            <div class="relative">
                               
                                <hotspot-richmedia
                                    :options='{
                                    icon: "diaporama",
                                    collection:  [
                                        {
                                            "src": getSpecificURL() + "fr/richmedia/page-023/amoa_81_master_passy_temoignages2018.mp4",
                                            "type": "html5video",
                                            "caption": "Chantier de remplacement de la conduite forcée de Passy (2012-2018)",
                                            "thumb": getSpecificURL() + "fr/images/thumbs/amoa_moe_france_et_international/Passy-1.jpg",
                                        },
                                        {
                                            "src": getSpecificURL() + "fr/richmedia/page-023/photo_passy.jpg",
                                            "type": "image",
                                            "caption": "Photo d’équipe : Passy en Haute-Savoie",
                                        }
                                    ] 
                                }'
                                    class="top-2 right-2"
                                />
                            
                                <image-with-descriptions
                                    :options="{
                                        image:
                                            'pages/' +
                                            currentPage.slug +
                                            '/' +
                                            currentPage.images.oImage4.src,
                                        descriptions: [
                                            {
                                                text: currentPage.images.oImage4
                                                    .edf,
                                                position: 'bottom-right', // top/bottom-left/right
                                                orientation: 'horizontal', // vertical, horizontal
                                            },
                                        ],
                                    }"
                                />
                            </div>
                        </div>
                    </div>
                    <div class="card">
                        <TitleParagraph
                            :options="{
                                from: 'from-sushi',
                                to: 'to-golden_sand',
                            }"
                        >
                            <!-- <Dots
                                :options="{
                                    colors: ['#81C341', '#B7DD92', '#cce5a4'],
                                }"
                            /> -->
                            <span
                                v-html="
                                    currentPage.content.sParagraphFive_Title
                                        .text
                                "
                            ></span>
                            <Triangles
                                :options="{
                                    colors: ['#81C341', '#B7DD92', '#cce5a4'],
                                    direction: 'bottom',
                                }"
                            />
                        </TitleParagraph>
                        <paragraph
                            :options="{
                                color: 'text-nandor',
                            }"
                        >
                            <span
                                v-html="
                                    currentPage.content.sParagraphFive_Content
                                        .text
                                "
                            ></span>
                        </paragraph>
                        <div class="relative">
                            <hotspot-richmedia
                                    :options="{
                                        icon: 'diaporama',
                                        collection: getRichmediaByCollection(
                                            currentPage,
                                            'Photo d’équipe : Aston en Ariège'
                                        ),
                                    }"
                                    class="top-2 right-2"
                                />
                            <image-with-descriptions
                                :options="{
                                    image:
                                        'pages/' +
                                        currentPage.slug +
                                        '/' +
                                        currentPage.images.oImage5.src,
                                    descriptions: [
                                        {
                                            text: currentPage.images.oImage5
                                                .edf,
                                            position: 'bottom-right', // top/bottom-left/right
                                            orientation: 'horizontal', // vertical, horizontal
                                        },
                                    ],
                                }"
                            />
                        </div>
                    </div>
                    <div class="card">
                        <div class="break-inside-avoid">
                            <div class="relative">
                                <image-with-descriptions
                                    :options="{
                                        image:
                                            'pages/' +
                                            currentPage.slug +
                                            '/' +
                                            currentPage.images.oImage6.src,
                                        descriptions: [
                                            {
                                                text: currentPage.images.oImage6
                                                    .edf,
                                                position: 'bottom-right', // top/bottom-left/right
                                                orientation: 'horizontal', // vertical, horizontal
                                            },
                                        ],
                                    }"
                                />
                                <hotspot-richmedia
                                    :options="{
                                        icon: 'diaporama',
                                        collection: getRichmediaByCollection(
                                            currentPage,
                                            'Remplacement des conduites forcées de Sabart (2017-2019)'
                                        ),
                                    }"
                                    class="top-2 right-2"
                                />
                            </div>
                            <TitleParagraph
                                :options="{
                                    from: 'from-sushi',
                                    to: 'to-golden_sand',
                                }"
                            >
                                <span
                                    v-html="
                                        currentPage.content.sParagraphSix_Title
                                            .text
                                    "
                                >
                                </span>
                                <Triangles
                                    :options="{
                                        colors: [
                                            '#81C341',
                                            '#B7DD92',
                                            '#cce5a4',
                                        ],
                                        direction: 'top',
                                    }"
                                />
                            </TitleParagraph>
                        </div>

                        <paragraph
                            :options="{
                                color: 'text-nandor',
                            }"
                        >
                            <span
                                v-html="
                                    currentPage.content.sParagraphSix_Content
                                        .text
                                "
                            >
                            </span>
                        </paragraph>
                    </div>
                    <div class="card">
                        <article-note
                            :options="{
                                image:
                                    'pages/' +
                                    currentPage.slug +
                                    '/' +
                                    currentPage.images.oImage7.src,
                                descriptions: [
                                    {
                                        text: currentPage.images.oImage7.edf,
                                        position: 'bottom-right', // top/bottom-left/right
                                        orientation: 'horizontal', // vertical, horizontal
                                    },
                                ],
                                verticalcontent:
                                    currentPage.content.sParagraphSeven_Title
                                        .text,
                                content:
                                    currentPage.content.sParagraphSeven_Quote
                                        .text,
                                color: {
                                    verticalcontent: 'text-cornflower_blue',
                                    content: 'text-nandor',
                                },
                                fontSize: {
                                    verticalcontent: 'text-3xl',
                                    content: '',
                                },
                                margin: {},
                            }"
                        />
                    </div>
                    <div class="card">
                        <TitleParagraph
                            :options="{
                                from: 'from-sushi',
                                to: 'to-golden_sand',
                            }"
                        >
                            <Triangles
                                :options="{
                                    colors: ['#81C341', '#B7DD92', '#cce5a4'],
                                    direction: 'bottom',
                                }"
                            />
                            <span
                                v-html="
                                    currentPage.content.sParagraphEight_Title
                                        .text
                                "
                            >
                            </span>
                        </TitleParagraph>

                        <paragraph
                            :options="{
                                color: 'text-nandor',
                            }"
                        >
                            <span
                                v-html="
                                    currentPage.content.sParagraphEight_Content
                                        .text
                                "
                            >
                            </span>
                            <!-- <Square
                                :options="{
                                    from: 'feijoa',
                                    to: 'selective_green',
                                }"
                            /> -->
                        </paragraph>
                        <div class="relative">
                            <image-with-descriptions
                                :options="{
                                    image:
                                        'pages/' +
                                        currentPage.slug +
                                        '/' +
                                        currentPage.images.oImage8.src,
                                    descriptions: [
                                        {
                                            text: currentPage.images.oImage8
                                                .edf,
                                            position: 'bottom-right', // top/bottom-left/right
                                            orientation: 'horizontal', // vertical, horizontal
                                        },
                                    ],
                                }"
                            />
                            <hotspot-richmedia
                                :options="{
                                    icon: 'diaporama',
                                    collection: getRichmediaByCollection(
                                        currentPage,
                                        'Remplacement de la conduite forcée à Pradières (2019-2021)'
                                    ),
                                }"
                                class="top-2 right-2"
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import PagesMixin from "@/mixins/PagesMixin";
import TitleSChapter from "../../components/TitleSChapter.vue";
import Triangles from "../../components/Triangles.vue";
import TitleParagraph from "../../components/TitleParagraph.vue";
import Paragraph from "../../components/Paragraph.vue";
import ImageWithDescriptions from "../../components/ImageWithDescriptions.vue";

export default {
    components: {
        TitleSChapter,
        Triangles,
        TitleParagraph,
        ImageWithDescriptions,
        Paragraph,
    },
    name : "PageTest",
    mixins: [PagesMixin],
};
</script>

<style scoped lang='scss'>
</style>
